import cookieUtil from "./cookieUtil";
import {AuthUserInfo} from "../pages/member/Service";
import {getKeFuUrl} from "./Service";

const GetAccountInfo = async (callback, isLogin) => {
    if (cookieUtil.has("access_token")) {
        let params = {
            access_token: cookieUtil.get("access_token")
        }
        AuthUserInfo(params).then(ret => {
            if (ret.code === '10000') {
                let accountInfo = ret.data.nickName;
                cookieUtil.put("nickName", accountInfo);
                cookieUtil.put("userGameId", ret.data.userGameId);
                //window.location.reload();
            }
            callback(ret, isLogin);
        })
    }
}

const captchaUrl = function () {
    return 'https://turing.captcha.qcloud.com/TCaptcha.js';
}
const captchaKeFuAppId = function () {
    return '195072099';
}
const captchaRegAppId = function () {
    return '196929822';
}

const jumpLogin = function (params) {
    let callbackurl = "?t=" + Math.random();
    if (params != undefined && params != "") {
        callbackurl += "&callback=" + encodeURIComponent(params);
    } else {
        callbackurl += "&callback=" + encodeURIComponent('https://m.91y.com');
    }
    //此处写绝对域名，用于外网兼容api.91y.com/mpay微信支付时未登录使用
    window.location.href = "https://h5business.91y.com/h5login" + callbackurl;
}

const jumpKeFu = function (token) {
    let urlParms = {};
    if (token != undefined && token != '') {
        urlParms.access_token = token;
    }
    getKeFuUrl(urlParms).then(ret => {
        if (ret.code === '10000') {
            const d = ret.data;
            window.open(d, '_blank', 'height=690,width=1110,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no');
        }
    }).catch(err => {
        console.log(err)
    });
}

const jumpOtherUrl = function (url) {
    if (url === '') {
        url = 'https://m.91y.com'
    }
    window.location.href = url;
}

export {GetAccountInfo, captchaUrl, jumpLogin, jumpKeFu, jumpOtherUrl, captchaKeFuAppId, captchaRegAppId};
